/**
 * Demo and QA records carry a "ZZ Demo" / "ZZ-QA" prefix so nobody mistakes
 * them for real people. Greetings and avatars skip it; full-name fields in
 * Profile still show it.
 */
const TEST_PREFIX = /^(zz[\s-]*(demo|qa)?\s+)+/i;

export function displayName(name: string | null | undefined): string {
  return (name ?? "").replace(TEST_PREFIX, "").trim();
}

/** First name for greetings; falls back to "there". */
export function firstName(name: string | null | undefined): string {
  const clean = displayName(name);
  if (!clean) return "there";
  return clean.split(/\s+/)[0] ?? clean;
}

export function initials(name: string | null | undefined): string {
  const parts = displayName(name).split(/\s+/).filter(Boolean);
  if (parts.length === 0) return "";
  const first = parts[0][0] ?? "";
  const last = parts.length > 1 ? parts[parts.length - 1][0] ?? "" : "";
  return (first + last).toUpperCase();
}
